import {RouteDefinition} from "../../../routes"
import {MultipleTemperatureEditScreen} from "./MultipleTemperatureEditScreen"
import {MultipleTemperatureListScreen} from "./MultipleTemperatureListScreen"

export const MultipleTemperatureRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/multiple-temperature/edit",
        component: MultipleTemperatureEditScreen
    },
    {
        routerLink: "/settings/multiple-temperature/edit/:id",
        component: MultipleTemperatureEditScreen
    },
    {
        routerLink: "/settings/multiple-temperature",
        component: MultipleTemperatureListScreen
    }
]
